import type { BindFeature } from '@wix/thunderbolt-catharsis-ioc'
import { CssFeatureSymbol } from '../../ioc/catharsis-ioc'
import type { SVGBackgroundImageCssFeature } from './SVGBackgroundImage.types'
import { svgBackgroundImage } from './SVGBackgroundImageCompNode'
import { svgBackgroundImageDomApplier } from './SVGBackgroundImageDomApplier'

export const svgBackgroundImageCssFeature: SVGBackgroundImageCssFeature = {
	featureName: 'svgBackgroundImage',
	experimentName: 'OPEN_TO_ALL',
	renderableNodes: { svgBackgroundImage },
	intermediateNodes: {},
	dataMaps: ['document_data', 'theme_data', 'variants_data'],
	domApplier: svgBackgroundImageDomApplier,
}

export const page: BindFeature = (bind) => {
	bind(CssFeatureSymbol).toConstantValue(svgBackgroundImageCssFeature)
}
export const editor: BindFeature = page
